'use client'

import { useMemo } from 'react'

import { useListSkillsQuery } from '~/data/api/client'
import type { AssistantSkill } from '~/data/api/client'

export type SkillSection = 'builtin' | 'personal' | 'organization'

export type GroupedAssistantSkills = {
  builtin: AssistantSkill[]
  personal: AssistantSkill[]
  organization: AssistantSkill[]
  all: AssistantSkill[]
  isLoading: boolean
  isError: boolean
}

export default function useAssistantSkills(organizationId: string | undefined, enabled: boolean): GroupedAssistantSkills {
  const { data, isLoading, isError } = useListSkillsQuery(
    { 'X-Organization-Id': organizationId ?? '', personalLimit: 50, organizationLimit: 50 },
    { skip: !enabled || !organizationId }
  )

  return useMemo(() => {
    const builtin = data?.builtinSkills ?? []
    const personal = data?.personalSkills ?? []
    const organization = data?.organizationSkills ?? []
    return {
      builtin,
      personal,
      organization,
      all: [...builtin, ...personal, ...organization],
      isLoading,
      isError
    }
  }, [data, isError, isLoading])
}

export function skillShareScope(skill: AssistantSkill): SkillSection {
  if (skill.shareScope === 'personal') return 'personal'
  if (skill.shareScope === 'organization') return 'organization'
  return 'builtin'
}
